import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "telemetry",
  "description": "`turbo telemetry` 명령어에 대한 API 레퍼런스"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "이 머신의 텔레메트리를 관리합니다."
  }, {
    "heading": "",
    "content": "Turborepo의 텔레메트리에 대해 자세히 알아보기."
  }, {
    "heading": "status",
    "content": "이 머신의 현재 텔레메트리 상태를 조회합니다."
  }, {
    "heading": "enable",
    "content": "이 머신의 텔레메트리를 활성화합니다."
  }, {
    "heading": "disable",
    "content": "이 머신의 텔레메트리를 비활성화합니다."
  }],
  "headings": [{
    "id": "인수",
    "content": "인수"
  }, {
    "id": "status",
    "content": "status"
  }, {
    "id": "enable",
    "content": "enable"
  }, {
    "id": "disable",
    "content": "disable"
  }]
};
import {LinkToDocumentation} from '#components/link-to-documentation';
export const toc = [{
  depth: 2,
  url: "#인수",
  title: _jsx(_Fragment, {
    children: "인수"
  })
}, {
  depth: 3,
  url: "#status",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "status"
    })
  })
}, {
  depth: 3,
  url: "#enable",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "enable"
    })
  })
}, {
  depth: 3,
  url: "#disable",
  title: _jsx(_Fragment, {
    children: _jsx("code", {
      children: "disable"
    })
  })
}];
function _createMdxContent(props) {
  const _components = {
    code: "code",
    h2: "h2",
    h3: "h3",
    p: "p",
    pre: "pre",
    span: "span",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " telemetry"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " [argument]"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "이 머신의 텔레메트리를 관리합니다."
    }), "\n", _jsx(LinkToDocumentation, {
      href: "/docs/telemetry",
      children: _jsx(_components.p, {
        children: "Turborepo의 텔레메트리에 대해 자세히 알아보기."
      })
    }), "\n", _jsx(_components.h2, {
      id: "인수",
      children: "인수"
    }), "\n", _jsx(_components.h3, {
      id: "status",
      children: _jsx(_components.code, {
        children: "status"
      })
    }), "\n", _jsx(_components.p, {
      children: "이 머신의 현재 텔레메트리 상태를 조회합니다."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " telemetry"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " status"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "enable",
      children: _jsx(_components.code, {
        children: "enable"
      })
    }), "\n", _jsx(_components.p, {
      children: "이 머신의 텔레메트리를 활성화합니다."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " telemetry"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " enable"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "disable",
      children: _jsx(_components.code, {
        children: "disable"
      })
    }), "\n", _jsx(_components.p, {
      children: "이 머신의 텔레메트리를 비활성화합니다."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " telemetry"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " disable"
            })]
          })
        })
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
